module.exports = __webpack_public_path__ + "img/arrow-left-black.fb1b5161.svg";